import { NavigationRoutes } from 'common/constants';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import {
  CardSection,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function RefundCardDetail() {
  const { t } = useTranslation();
  const { navigate } = useNavigation();

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <SectionContainer>
        <Text variant="HeadingXSmall">{t('common:refund_detail')}</Text>
        <HOCInput keys={['approvalable']}>
          {(value) => (
            <Button
              buttonType="secondary"
              onClick={() =>
                navigate(NavigationRoutes.RefundView, {
                  id: value.approvalable.id,
                })
              }
            >
              {t('common:view_old_data')}
            </Button>
          )}
        </HOCInput>
      </SectionContainer>
      <Separator gap={16} />
      <HalfContainer>
        <Input
          type="text"
          name="approvalable.number"
          label={t('common:number')}
        />
      </HalfContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.requestedAt"
            label={t('refund:requested_at')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.reason"
            label={t('refund:refund_reason')}
          />
        </HalfContainer>
      </SectionContainer>

      <Separator gap={16} direction="vertical">
        <Text variant="HeadingXSmall">{t('common:refund_customer')}</Text>
      </Separator>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.releaseSale.number"
            label={t('refund:requested_at')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="number"
            name="approvalable.releaseSale.amount"
            label={t('refund:refund_amount')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.releaseSale.customer"
            label={t('common:customer')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="number"
            name="approvalable.releaseSale.customerBilling"
            label={t('common:billing_to')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.releaseSale.paymentMethod"
            label={t('common:payment_method')}
          />
        </HalfContainer>
        <HOCInput keys={['approvalable.releaseSale.paymentMethod']}>
          {(_value) => {
            const value = _value['approvalable.releaseSale.paymentMethod'];
            return (
              <HalfContainer>
                <Input
                  type="text"
                  name="approvalable.releaseSale.paymentable"
                  label={value}
                />
              </HalfContainer>
            );
          }}
        </HOCInput>
      </SectionContainer>

      <HOCInput keys={['approvalable']}>
        {(value) => {
          if (!value.approvalable.releasePurchase) {
            return <></>;
          }
          return (
            <>
              <Separator gap={16} direction="vertical">
                <Text variant="HeadingXSmall">{t('common:refund_agent')}</Text>
              </Separator>
              <SectionContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name="approvalable.releasePurchase.number"
                    label={t('refund:requested_at')}
                  />
                </HalfContainer>
                <HalfContainer>
                  <Input
                    type="number"
                    name="approvalable.releasePurchase.amount"
                    label={t('refund:refund_amount')}
                  />
                </HalfContainer>
              </SectionContainer>
              <SectionContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name="approvalable.releasePurchase.agent"
                    label={t('common:agent')}
                  />
                </HalfContainer>
              </SectionContainer>
              <SectionContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name="approvalable.releasePurchase.paymentMethod"
                    label={t('common:payment_method')}
                  />
                </HalfContainer>
                <HalfContainer>
                  <Input
                    type="text"
                    name="approvalable.releasePurchase.paymentable"
                    label={value.approvalable.releasePurchase.paymentMethod}
                  />
                </HalfContainer>
              </SectionContainer>
            </>
          );
        }}
      </HOCInput>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
